// App context for the sheet service

import { NavItems } from "@/components/nav-actions";
import { Context, createContext, useContext, useEffect } from "react";

export type sheetCtx = {
  open: boolean;
  close: (closeFn: () => void) => void;
  title: string;
  setTitle: (title: string) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  titleExtras?: NavItems;
  setTitleExtras: (titleExtras: NavItems) => void;
};

const initialValue: sheetCtx = {
  open: true,
  close: () => {},
  title: "",
  setTitle: () => {},
  isLoading: false,
  setIsLoading: () => {},
  titleExtras: undefined,
  setTitleExtras: () => {},
};

export const SheetContextProvider = createContext(
  initialValue
) as Context<sheetCtx>;

export function useSheetContext() {
  return useContext<sheetCtx>(SheetContextProvider);
}

export function useSyncLoading(loading: boolean) {
  const { isLoading, setIsLoading } = useSheetContext();
  useEffect(() => {
    if (isLoading === loading) return;
    setIsLoading(loading);
  }, [isLoading, loading, setIsLoading]);
}

export function useSyncTitle(title: string) {
  const { title: currentTitle, setTitle } = useSheetContext();
  useEffect(() => {
    if (currentTitle === title) return;
    setTitle(title);
  }, [currentTitle, title, setTitle]);
}

export function useSetSheetTitleExtras(extras: NavItems = []) {
  const { setTitleExtras } = useSheetContext();
  useEffect(() => {
    setTitleExtras(extras);
  }, [extras, setTitleExtras]);
}
